import styled from 'styled-components';
import { InfiniteList } from '../../../molecules/InfiniteList';

export const Option = styled.li<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  padding: 0 1rem;
  min-height: 45.5px;
  background-color: ${({ $selected, theme }) =>
    $selected ? theme.colors.lightGrey : null};
  word-break: break-word;
  cursor: pointer;
`;

export const Options = styled.ul`
  position: absolute;
  box-sizing: border-box;
  width: calc(100% - 2px);
  margin: 0 1px;
  padding: 0;
  z-index: 10;
  max-height: 20rem;
  top: 52px;

  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  list-style-type: none;

  &:hover ${Option} {
    background-color: transparent;
  }

  &:hover ${Option}:hover {
    background-color: ${({ theme }) => theme.colors.lightGrey};
  }
`;

export const EmptyOption = styled.div`
  margin: 0.5rem;
`;

export const StyledInfiniteList = styled(InfiniteList)`
  max-height: 20rem;
`;
